var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#5282FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.985 23.408L23.227 27.094C24.427 28.459 25.028 29.142 25.657 28.975C26.285 28.809 26.501 27.911 26.932 26.114L29.322 16.146C29.987 13.378 30.319 11.995 29.581 11.312C28.843 10.629 27.564 11.137 25.006 12.152L13.14 16.865C11.094 17.678 10.071 18.084 10.006 18.782C9.99833 18.8532 9.99833 18.9249 10.006 18.996C10.069 19.695 11.09 20.104 13.134 20.923C14.059 21.294 14.522 21.48 14.854 21.835C14.8913 21.875 14.9273 21.9164 14.962 21.959C15.268 22.339 15.398 22.839 15.659 23.835L16.148 25.702C16.401 26.672 16.528 27.158 16.861 27.224C17.194 27.29 17.483 26.888 18.062 26.083L19.985 23.408ZM19.985 23.408L19.668 23.078C19.306 22.7 19.125 22.512 19.125 22.278C19.125 22.044 19.305 21.855 19.668 21.478L23.241 17.754",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.2ebc33b03840ec62ac60c8078f303969.svg";
export { ForwardRef as ReactComponent };